import { PostTypeReel } from '~publish/legacy/post/constants'

const instagramHashtagRegex = /#[\w\p{L}\p{N}\p{M}\p{S}\u200d]{1,30}/gu
const instagramMentionRegex =
  /@(?!\.)[a-zA-Z0-9](?:[a-zA-Z0-9._]*[a-zA-Z0-9])?(?:\b|(?=\s|$))/g

interface ParsedEntity {
  displayString: string
  indices: [number, number]
  rawString: string
  className: string
}

const parseInstagramLinks = (
  postType: string,
  text?: string | null,
): ParsedEntity[] => {
  if (!text) return []

  const entities: ParsedEntity[] = []

  const hashtagMatches = text.matchAll(instagramHashtagRegex)
  for (const match of hashtagMatches) {
    if (match.index !== undefined) {
      entities.push({
        displayString: match[0],
        indices: [match.index, match.index + match[0].length],
        rawString: match[0],
        className: postType === PostTypeReel ? 'is-reel' : '',
      })
    }
  }

  const mentionMatches = text.matchAll(instagramMentionRegex)
  for (const match of mentionMatches) {
    if (
      match.index !== undefined &&
      !/[a-zA-Z0-9._@]/.test(text.charAt(match.index - 1))
    ) {
      entities.push({
        displayString: match[0],
        indices: [match.index, match.index + match[0].length],
        rawString: match[0],
        className: postType === PostTypeReel ? 'is-reel' : '',
      })
    }
  }

  entities.sort((a, b) => a.indices[0] - b.indices[0])

  return entities
}

export { parseInstagramLinks }
